import React, { FC, ReactNode } from 'react';

import s from './DateTimeSnippet.module.scss';

type DateTimeSnippetProps = {
  children: ReactNode;
};

const DateTimeSnippet: FC<DateTimeSnippetProps> = ({
  children,
}) => (
  <div className={s.root}>
    <div className={s.content}>
      {children}
    </div>
  </div>
);
export default DateTimeSnippet;
